jQuery(document).ready(function($) {

    /* OPEN Wrapper */
    const toggleBtn = document.getElementById('indexToggle');
    const slidingDiv = document.getElementById('index-wrapper');
    const closeBtn = document.getElementById('closeBtn');
    const closeBtn2 = document.getElementById('closeBtn2');

    function addOverflowHiddenClass() {
        // Check if window width is less than 420px
        if (window.innerWidth < 420) {
            document.body.classList.add('overflow-hidden');
            document.body.classList.add('h-[999999px]');
        }
    }

    function removeOverflowHiddenClass() {
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('h-[999999px]');
    }

    toggleBtn.addEventListener('click', () => {
        slidingDiv.classList.toggle('open');
        toggleBtn.classList.toggle('open');

        addOverflowHiddenClass();
    });

    closeBtn.addEventListener('click', () => {
        slidingDiv.classList.remove('open');
        toggleBtn.classList.remove('open');

        removeOverflowHiddenClass();
    });

    closeBtn2.addEventListener('click', () => {
        slidingDiv.classList.remove('open');
        toggleBtn.classList.remove('open');

        removeOverflowHiddenClass();
    });
    /* OPEN Wrapper END */

// Click outside #index-wrapper or #indexToggle to close
    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!slidingDiv.contains(target) && !target.matches('#indexToggle')) {
            slidingDiv.classList.remove('open');
            toggleBtn.classList.remove('open');

            removeOverflowHiddenClass();
        }
    });

    /* Section ID */
    // Find all <section> tags
    var sections = $('section');

    // Create section index
    var sectionIndex = $('#section-index');

// Iterate over each section
    sections.each(function(index) {

        // Find the first <h2> or <h3> tag within the section
        var heading = $(this).find('h2, h3').first();

        // Create an index item with a link to the section
        var indexItem = $('<li></li>').text(heading.text());
        indexItem.click(function() {
            // Scroll to the corresponding section with an offset of 100px less
            $('html, body').animate({
                scrollTop: sections.eq(index).offset().top - 104,
            }, 50);
        });

        // Append the index item to the section index
        sectionIndex.append(indexItem);
    });

    // Add scroll event listener to highlight active section
    $(window).scroll(function() {
        var scrollPosition = $(window).scrollTop();
        sections.each(function(index) {

            var sectionTop = $(this).offset().top - 105; // Adjusted for triggering 100px before
            var sectionBottom = sectionTop + $(this).outerHeight();

            if (scrollPosition >=
                sectionTop &&
                scrollPosition <
                sectionBottom) {
                // Add 'active' class to the current section
                sections.removeClass('active');
                $(this).addClass('active');

                // Update the active item in the section index
                sectionIndex.find('li').removeClass('active');
                sectionIndex.find('li').eq(index).addClass('active');
            }
        });

        // Update the active class for <li> based on section's active class
        sections.each(function(index) {
            if ($(this).hasClass('active')) {
                sectionIndex.find('li').removeClass('active');
                sectionIndex.find('li').eq(index).addClass('active');
            }
        });

    });

    // Close index wrapper when clicking an li under #section-index
    //$('#section-index li').on('click', () => {
    //    slidingDiv.classList.remove('open');
    //    toggleBtn.classList.remove('open');
    ///});

});

jQuery(document).ready(function($) {

    var resizeTimeout;

    // Set to full height if index > window
    function toggleClass() {
        var windowHeight = jQuery(window).height();
        var wrapperHeight = jQuery('#section-index').height() + 100;

        if (wrapperHeight >= windowHeight) {
            jQuery('#index-wrapper').addClass('h-full');
        } else {
            jQuery('#index-wrapper').removeClass('h-full');
        }
    }

    // Trigger the class change initially to check the height on page load
    toggleClass();

    // Trigger class change on window resize
    $(window).on('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            toggleClass();
            console.log('reSize');
        }, 250); // Adjust the delay as needed
    });

});

window.onload = function() {
    var ul = document.getElementById('section-index');
    var lis = ul.getElementsByTagName('li');

    for (var i = 0; i < lis.length; i++) {
        if (lis[i].textContent.trim() === '') {
            lis[i].style.display = 'none';
        }
    }
};

//# sourceMappingURL=site-index.js.map
